import { forwardRef, type Ref, type SVGProps } from "react";
const IconLaundryFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 26a7 7 0 0 1-6.94-6.13A6 6 0 0 1 9 19v-.44c1.14-1.08 3.3-2 7 .44s5.84 1.52 7 .44A7 7 0 0 1 16 26"
    />
    <path
      fill="currentColor"
      d="M26 2H6a3 3 0 0 0-3 3v23a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V5a3 3 0 0 0-3-3M8 6h4a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2m8 22a9 9 0 1 1 9-9 9 9 0 0 1-9 9"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLaundryFilledSVG);
ForwardRef.displayName = "IconLaundryFilled";
export { ForwardRef as IconLaundryFilled };
